import React from 'react';
import FetchDataWrapper from '../../../../../../components/FetchDataWrapper';
import { useCompaniesQuery } from '../../../../api/companies';

const InitialDataFetcher = ({ children, className }) => {
  const {
    data: companies,
    isFetching: isCompaniesFetching,
    refetch: companiesRefetch,
  } = useCompaniesQuery();

  return (
    <FetchDataWrapper
      className={className}
      data={companies}
      isFetching={isCompaniesFetching}
      refetch={companiesRefetch}
      errMsg="Не удалось получить список компаний. Без них невозможно продолжить работу с приемками"
    >
      {children}
    </FetchDataWrapper>
  );
};

export default InitialDataFetcher;
